import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IQutationRFQStatsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any[]
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const qutationRFQStatsSlice = createSlice({
    name: 'company-statistics/qutation-RFQ-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IQutationRFQStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const qutationRFQStatsActions = qutationRFQStatsSlice.actions
export default qutationRFQStatsSlice.reducer
